import { render, staticRenderFns } from "./ImgSingleProperty.vue?vue&type=template&id=21865743&scoped=true"
import script from "./ImgSingleProperty.vue?vue&type=script&lang=js"
export * from "./ImgSingleProperty.vue?vue&type=script&lang=js"
import style0 from "./ImgSingleProperty.vue?vue&type=style&index=0&id=21865743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21865743",
  null
  
)

export default component.exports